<template>
  <div class="numberInput">
    <div class="numberInput-name">{{name}}</div>
    <div class="numberInput-field">
      <input type="number" v-model="value">
    </div>
  </div>
</template>

<script>
import Input from '@/inputs/Input'

export default {
  extends: Input,
  props: ['name']
}
</script>

<style lang="sass">
@import './../sass/core.sass'

+block('numberInput')

  +element('name')
    padding-top: 9px
    padding-left: 25px
    text-transform: capitalize
    font-size: 12px
    margin-bottom: 12px

</style>



// WEBPACK FOOTER //
// src/inputs/Number.vue